export default __webpack_public_path__ + "static/media/Harpreet singh.3c0779c4.jpg";